export default __webpack_public_path__ + "static/DG_logo_mid_res-11415aeded0e79a8198f5797699644bd.jpg";